module.exports = __webpack_public_path__ + "img/book-rect-icon.57c17d2c.svg";